import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import PaginaProducto from './components/PaginaProducto';
import Carrito from './components/Carrito';
import Checkout from './components/Checkout';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import TiendaPage from './components/tiendaPage';
import PaginaCombo from './components/PaginaCombo';
import { CarritoProvider } from './context/carritoContext';

const App = () => {
  return (
    <CarritoProvider>
      <Router>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/producto/:slug" element={<PaginaProducto />} />
            <Route path="/carrito" element={<Carrito />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/tienda" element={<TiendaPage />} />
            <Route path="/combos/:id" element={<PaginaCombo />} />
          </Routes>
        </Layout>
      </Router>
    </CarritoProvider>
  );
};

export default App;
